import { ClinicsService } from 'src/app/core/services/clinics.service';
import { map } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { PatientModel } from 'src/app/core/models/patient.model';
import { PermissionConst } from 'src/app/core/models/permission-const.model';
import { PhoneModel } from 'src/app/core/models/phone.model';
import { BrapiService } from 'src/app/core/services/brapi.service';
import { PatientService } from 'src/app/core/services/patient.service';
import { RegistersService } from 'src/app/core/services/registers.service';
import { SessionManagerService } from 'src/app/core/services/session-manager.service';
import { Options } from 'src/app/shared/components/select-input/models/Options';
import { FieldValidator } from 'src/app/shared/renderers/utils/field-validator/field-validator';
import { ClinicModel } from 'src/app/core/models/clinic.model';


@Component({
  selector: 'app-patient-register',
  templateUrl: './patient-register.component.html',
  styleUrls: ['../patients.scss']
})
export class PatientRegisterComponent implements OnInit {

  addressFormGroup = this.fb.group({
    zipcode: [],
    address: [],
    number: [],
    complement: [],
    neighborhood: [],
    city: [],
    state: []
  });

  searchZipcode: boolean = false;

  formGroup = this.fb.group({
    id: [],
    name: [null, [Validators.required]],
    display_name: [],
    gender: [],
    birthdate: [],
    email: [],
    document_number: ['', [FieldValidator.documentValidator()]],
    marital_status: [],
    profession: [],
    type: ['COMPANY'],
    clinic: [],
    clinics: this.fb.array([]),
    tags: [[]],
    phone_numbers: this.fb.array([]),
    address: this.addressFormGroup,
    country_code: ['+55', [Validators.required]],
    phone_number: [null, [Validators. required, Validators.maxLength(13)]]
  });

  imageFile!: File | null;
  changedImage: boolean = false;

  loadingAccount: boolean = false;

  clearClinicSearch: boolean = false;
  loadingClinic: boolean = false;

  patientTagsList!: Options[];
  fetchingTags: boolean = false;
  professionList!: Options[];
  fetchingProfession: boolean = false;

  submitting: boolean = false;
  submitButton: String = "Salvar";
  connect: boolean = false;

  phonesList!: PhoneModel[];

  clinicsList: Options[] = [];
  clinicsAll!: Options[];
  clinicsListAll!: Options[];
  fetchingClinic: boolean = false;
  clinicData?: ClinicModel;



  phoneTypeList: Options[] = [
    { label: "Whatsapp", value: "WHATSAPP" },
    { label: "Comercial", value: "COMERCIAL" },
    { label: "Residencial", value: "RESIDENTIAL" },
  ];

  maritalStatusList: Options[] = [
    { value: "MARRIED", label: "Casado" },
    { value: "SINGLE", label: "Solteiro" },
    { value: "DIVORCED", label: "Divorciado" },
    { value: "WIDOWED", label: "Viúvo" }
  ];

  maskSearch: string = '00.000.000/0000-00';

  constructor(@Inject(DOCUMENT) private document: Document, private fb: FormBuilder, private sessionManager: SessionManagerService,
    private router: Router, private toast: ToastrService, private registersService: RegistersService, private patientService: PatientService,
    private brApiService: BrapiService,
    private clinicsService: ClinicsService) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.addPhoneNumber();
    this.fetchClinic();
    this.fetchProfessionsList();
    this.fetchPatientTags();
  }

  onImageSelect(file: any) {
    this.imageFile = file;
    this.changedImage = true
  }

  submitHandler() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      this.submitting = true;
      (this.phoneNumbersForms?.value as PhoneModel[]).forEach((phone, index) => {
        this.phoneNumbersForms.at(index)?.get('id')?.setValue(undefined);
      });
      const patientData = this.formGroup.getRawValue();
      if (this.connect && !this.isSuperUserOrStaff) {
        this.connectPatient();
      } else {
        this.patientRegister(patientData);
      }
    } else {
      this.toast.error("Preencha corretamente os campos obrigatórios", "Erro");
      this.document.getElementById('main-container')?.scroll({ top: 0 });
    }
  }

  connectPatient() {
    let patient_id = this.formGroup.get('id')?.value;
    this.patientService.connect(this.currentClinicId, patient_id).subscribe(response => {
      if (this.changedImage) {
        this.patientService.uploadImage(this.imageFile!, response.id!, this.currentClinicId).subscribe(() => { });
      }
      this.toast.success("Paciente conectado com sucesso", "Sucesso");
      this.cancelHandler();
      this.submitting = false;
    }, (error: HttpErrorResponse) => {
      this.mapErrorResponse(error);
      this.submitting = false;
    });
  }

  get fetchingData(): boolean {
    if (this.fetchingTags && this.fetchingProfession) {
      return true;
    }
    return false;
  }

  get currentClinic() {
    if(!this.isSuperUserOrStaff) {
      return this.sessionManager.getClinicCurrent();
    }
    return '';
  }

  get currentClinicId() {
    if(!this.isSuperUserOrStaff) {
      return this.sessionManager.getClinicCurrent().value;
    }
    return '';
  }

  get isSuperUserOrStaff() {
    return this.sessionManager.isSuperUserOrStaff();
  }

  searchAccount() {
    let phone_number = this.formGroup.get('phone_number')?.value
    let country_code = this.formGroup.get('country_code')?.value
    let encodedCountryCode = encodeURIComponent(country_code)
    this.loadingAccount = true;
    this.patientService.searchPatientByPhoneNumber(phone_number, encodedCountryCode).subscribe(response => {
      if (response) {
        this.setForm(response);
      }
      this.loadingAccount = false;
    }, (error) => {
      this.loadingAccount = false;
    });
  }

  setForm(data: any) {
    if(data.account) {
      if (this.isSuperUserOrStaff && data.account.is_patient) {
        this.router.navigate([`dashboard/patients/edit/${data.id}`]);
      } else {
        this.formGroup.patchValue(data.account);
      }
      if (!this.isSuperUserOrStaff) {
        let connectClinic = data.clinics.find((item: any) => item == this.currentClinicId);
        if ((connectClinic != undefined) && data.account.is_patient) {
          this.router.navigate([`dashboard/patients/edit/${data.id}`]);
        }
        if (!data.account.is_patient) {
          this.formGroup.patchValue(data);
        } else {
          if (data.account.is_staff || data.account.is_superuser) {
            this.formGroup.disable();
            this.formGroup.get('document_number')?.enable();
          }
          this.formGroup.patchValue(data);
          this.connect = true;
          this.submitButton = "Conectar";
        }
      }
    } else {
      if (this.isSuperUserOrStaff && data.is_patient) {
        this.router.navigate([`dashboard/patients/edit/${data.id}`]);
      } else {
        this.formGroup.patchValue(data);
      }
      if (!this.isSuperUserOrStaff) {
        let connectClinic = data.clinics.find((item: any) => item == this.currentClinicId);
        if ((connectClinic != undefined) && data.is_patient) {
          this.router.navigate([`dashboard/patients/edit/${data.id}`]);
        }
        if (!data.is_patient) {
          this.formGroup.patchValue(data);
        } else {
          if (data.is_staff || data.is_superuser) {
            this.formGroup.disable();
            this.formGroup.get('document_number')?.enable();
          }
          this.formGroup.patchValue(data);
          this.connect = true;
          this.submitButton = "Conectar";
        }
      }
    }
  }

  patientRegister(patientData: PatientModel) {
    patientData.id = undefined;
    const fnResponse = (response: PatientModel) => {
      if (this.changedImage) {
        if (this.isSuperUserOrStaff) {
          this.patientService.uploadImage(this.imageFile!, response.account!.id!).subscribe(() => { }, fnError);
        }
      }
      this.submitting = false;
      this.toast.success('Paciente criado com sucesso', "Sucesso");
      this.cancelHandler();
    };

    const fnError = (error: HttpErrorResponse) => {
      this.mapErrorResponse(error);
      this.submitting = false;
    };

    if(this.isSuperUserOrStaff) {
      this.patientService.patientRegister(patientData).subscribe(fnResponse, fnError);
    } else {
      this.patientService.clinicUserPatientRegister(this.currentClinicId, patientData).subscribe(fnResponse, fnError);
    }
  }

  fetchProfessionsList() {
    this.registersService.professionsAll(this.currentClinicId).subscribe(response => {
      this.professionList = response!.map(items => {
        return {
          value: items.id!.toString(),
          label: items.name
        } as Options;
      });
      this.fetchingProfession = true;
    });
  }

  fetchPatientTags() {
    this.patientService.listAllTagPatient(this.currentClinicId).subscribe(response => {
      this.patientTagsList = response!.map(items => {
        return {
          value: items.id!.toString(),
          label: items.name
        } as Options;
      });
      this.fetchingTags = true;
    });
  }

  get clinicsFormArray(): FormArray {
    return this.formGroup.get('clinics') as FormArray;
  }

  setClinic() {
    this.loadingClinic = true;
    this.formGroup.get('clinic')?.disable();
    let document_number = this.formGroup.get('clinic')?.value;
    if (document_number) {
      this.clearClinicSearch = true;
      this.patientService.clinicSearchAll(document_number).subscribe(response => {
        this.formGroup.get('clinic')?.enable();
        let hasClinic = this.clinicsFormArray.value.some((id: any) => response.id == id);
        if (hasClinic) {
          this.formGroup.get('clinic')?.setErrors({
            response: 'Esta clínica já foi adicionada'
          });
        } else {
          this.clearClinic();
          this.clinicsFormArray.push(this.fb.control(response.id));
          this.clinicsList = this.clinicsListAll.filter((item) => {
            return this.clinicsFormArray.value.some((id: any) => item.value == id);
          });
        }
        this.loadingClinic = false;
      }, (error) => {
        this.formGroup.get('clinic')?.setErrors({
          response: 'Não existe clínica com esse CNPJ/CPF'
        });
      });
      this.formGroup.get('clinic')?.enable();
    } else {
      this.formGroup.get('clinic')?.setErrors({
        response: 'Digite um CNPJ para pesquisar'
      });
      this.loadingClinic = false;
      this.formGroup.get('clinic')?.enable();
    }
  }

  clearClinic() {
    this.maskSearch = '00.000.000/0000-00';
    this.formGroup.get('clinic')?.enable();
    this.formGroup.get('clinic')?.reset();
    this.clearClinicSearch = false;
  }

  fetchClinic() {
    const fnResponse = (response: any) => {
      this.clinicsListAll = response!.map((item: any) => {
        return {
          value: item.id,
          label: `${item.name}`
        } as Options;
      });
      this.clinicsAll = this.clinicsListAll;
      this.fetchingClinic = true;
    }
    const fnError = (error: HttpErrorResponse) => {
      this.mapErrorResponse(error);
    };
    this.clinicsService.getAll(this.currentClinicId).subscribe(fnResponse, fnError);
  }


  removeClinic(clinic: any) {
    let index = this.clinicsList.indexOf(clinic);
    this.clinicsList.splice(index, 1);
    let formArrayIndex = this.clinicsFormArray.value.indexOf(clinic.value);
    this.clinicsFormArray.removeAt(formArrayIndex);
  }

  get canSave() {
    return this.sessionManager.getUserPermission(PermissionConst.add_patient);
  }

  cancelHandler() {
    this.router.navigate(['dashboard/patients']);
  }

  get phoneNumbersForms() {
    return this.formGroup.get('phone_numbers') as FormArray;
  }

  getPhoneNumberForm(index: number) {
    return this.phoneNumbersForms.controls[index] as FormGroup;
  }

  addPhoneNumber() {
    let phoneNumberFormGroup = this.fb.group({
      id: [],
      country_code: ['+55'],
      phone_number: [null, [Validators.required]],
      type: ['WHATSAPP'],
      is_active: [true]
    });
    this.phoneNumbersForms.push(phoneNumberFormGroup);
  }

  removePhoneNumber(at: number) {
    let formGroup = this.getPhoneNumberForm(at);
    if (formGroup.get('id')?.value) {
      formGroup.patchValue({ is_active: false });
    } else {
      this.phoneNumbersForms.removeAt(at);
    }
  }

  phoneNumberIsActive(index: number) {
    return this.getPhoneNumberForm(index).get('is_active')?.value;
  }

  handleZipCodeChange(ev: any) {
    this.searchZipcode = true;
    let zipcode = this.addressFormGroup.get('zipcode')?.value;
    this.addressFormGroup.disable();
    this.brApiService.getAddressByZipCode(zipcode).subscribe(response => {
      this.addressFormGroup.patchValue({
        address: response.street,
        neighborhood: response.neighborhood,
        city: response.city,
        state: response.state
      });
      this.searchZipcode = false;
      this.addressFormGroup.enable();
    }, (error: HttpErrorResponse) => {
      this.addressFormGroup.get('zipcode')?.setErrors({response: 'Cep não encontrado'});
      this.searchZipcode = false;
      this.addressFormGroup.enable();
    });
  }

  mapErrorResponse(errorResponse: HttpErrorResponse) {
    if (errorResponse.error["detail"]) {
      this.toast.error(errorResponse.error["detail"], "Erro");
      this.document.getElementById('main-container')?.scroll({ top: 0 });
    } else {
      this.setFormErrors(errorResponse);
      this.document.getElementById('main-container')?.scroll({ top: 0 });
    }
  }

  setFormErrors(errorResponse: HttpErrorResponse) {
    let errNames = [
      "name", "display_name", "gender", "email", "birthdate", "document_number", "tags",
      "phone_numbers", "marital_status", "profession", "identity_number"
    ];

    let addressErrNames = [
      "zipcode", "address", "number", "complement", "neighborhood", "city", "state"
    ];

    let phoneErrNames = [
      "id", "country_code", "phone_number", "type"
    ];

    errNames.forEach(name => {
      if (errorResponse.error[name]) {
        this.formGroup.get(name)?.setErrors({ response: errorResponse.error[name] });
      }
    });

    if (errorResponse.error.address) {
      let address = errorResponse.error.address;
      addressErrNames.forEach(name => {
        this.addressFormGroup.get(name)?.setErrors({ response: address[name] });
      });
    }

    if (errorResponse.error.phone_numbers) {
      let phone_numbers: [] = errorResponse.error.phone_numbers;
      phone_numbers.forEach((obj, index) => {
        let formPhone = this.getPhoneNumberForm(Number(index)) as FormGroup;
        phoneErrNames.forEach(name => {
          formPhone.get(name)?.setErrors({ response: obj[name] });
        });

      });
    }
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    return true;
  };

  onSubtypeSelected(value?: string) {
    if (value == "COMPANY") {
      this.maskSearch = "00.000.000/0000-00";
    }
    else {
      this.maskSearch = "000.000.000-00";
    }
  }

}
